import { useCurrentUser } from '@/react/hooks/useUser';

import { Alert } from '@@/Alert';
import { LinkButton } from '@@/LinkButton';

export function RegistryAlert({
  registryId,
  isOCI,
}: {
  registryId?: number;
  isOCI?: boolean;
}) {
  const { isPureAdmin: hasRegistryEditPermission } = useCurrentUser();

  if (!isOCI) {
    return (
      <Alert color="error">
        Portainer was unable to get Helm charts from the Helm repository. Is the
        Helm repository reachable?
      </Alert>
    );
  }

  if (hasRegistryEditPermission) {
    return (
      <Alert color="error">
        <div>
          Portainer was unable to get Helm charts from this OCI registry. Is it
          configured correctly?{' '}
          {!!registryId && (
            <LinkButton
              to="portainer.registries.registry.configure"
              params={{ id: registryId }}
              data-cy="configure-registry-link"
              target="_blank"
              rel="noreferrer"
              color="secondary"
              className="!mt-2"
            >
              Configure registry
            </LinkButton>
          )}
        </div>
      </Alert>
    );
  }

  return (
    <Alert color="error">
      Portainer was unable to get Helm charts from this OCI registry. Please
      contact your administrator to update the registry configuration.
    </Alert>
  );
}
